import createReactContext from '@ant-design/create-react-context';
export var FormContext = createReactContext({
  labelAlign: 'right',
  vertical: false
});
//# sourceMappingURL=context.js.map



//////////////////
// WEBPACK FOOTER
// ./~/antd/es/form/context.js
// module id = 324
// module chunks = 3